import { useEffect } from 'react';
import Menu from '../../../commons/Menu/Menu';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Menu />
      <div style={{ padding: 8 }}>
        <p style={{ whiteSpace: 'pre-line' }}>
          PROTECTION DES DONNÉES PERSONNELLES <br />
          1. DÉFINITION ET NATURE DES DONNÉES À CARACTÈRE PERSONNEL <br />
          Lors de votre utilisation du site https://www.publiconsult.fr (ci-après : le «Site») et
          lorsque vous avez recours aux services de la société LENS GROUP (ci-après : les
          «Services»), (i) en tant qu’entreprises souhaitant recevoir du lead selon les critères de
          correspondance (ci-après : les «Entreprises») ou (ii) en tant que acheteurs publics
          souhaitant recevoir des devis de la part des Entreprises (ci-après : les «Acheteurs
          Publics»), nous pouvons être amenés à vous demander de nous communiquer des données à
          caractère personnel vous concernant, afin d’utiliser les services que nous proposons
          (ci-après, les «Services»). <br />
          Dans le cadre de la présente charte, le terme « données à caractère personnel » désigne
          toutes les données qui permettent d’identifier un individu, ce qui correspond notamment :{' '}
          <br />
          pour les Entreprises : à vos nom, prénoms, adresses postales et de courrier électronique,
          KBIS, numéros de téléphone, ainsi qu’à tout autre renseignement que vous choisirez de nous
          communiquer à votre sujet. <br />
          pour les Acheteurs Publics : à vos nom, prénoms, adresses postales et de courrier
          électronique, KBIS, nom, prénom du responsable administratif, numéros de téléphone,
          document justifiant de votre identité, ainsi qu’à tout autre renseignement que vous
          choisirez de nous communiquer à votre sujet. <br />
          <br />
          2. OBJET DE LA PRÉSENTE CHARTE <br />
          <br />
          La présente charte a pour objet de vous informer sur les moyens que nous mettons en œuvre
          pour collecter vos données à caractère personnel, dans le respect le plus strict de vos
          droits. <br />
          Nous vous indiquons à ce sujet que nous nous conformons, dans la collecte et la gestion de
          vos données à caractère personnel, à la loi n°78-17 du 6 janvier 1978 relative à
          l'informatique, aux fichiers et aux libertés, dans sa version actuelle (ci-après : la «Loi
          Informatique et Libertés»), ainsi qu’au règlement (UE) 2016/679 du 27 avril 2016 relatif à
          la protection des personnes physiques à l'égard du traitement des données à caractère
          personnel et à la libre circulation de ces données (ci-après : le «RGPD»). <br />
          <br />
          3. IDENTITÉ DU RESPONSABLE DE LA COLLECTE DE DONNÉES <br />
          <br />
          Le responsable de la collecte de vos données à caractère personnel est la société LENS
          GROUP, société par actions simplifiée, immatriculée au Registre du Commerce et des
          Sociétés de Paris sous le n° 847 550 910, ayant son siège social 2 Bis Avenue du Docteur
          Cartade 66310 ESTAGEL (ci-après: «Nous»). <br />
          <br />
          <br />
          4. POINT DE CONTACT EN MATIÈRE DE PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL <br />
          Nous avons nommé un point de contact en matière de protection des données à caractère
          personnel, dont les coordonnées sont les suivantes : contact@publiconsult.fr <br />
          <br />
          5. COLLECTE DES DONNÉES À CARACTÈRE PERSONNEL <br />
          <br />
          Le fondement légal de notre collecte de vos données personnelles est le suivant : <br />
          (i) L’intérêt légitime lorsque vous nous fournissez volontairement des données à caractère
          personnel lors de votre visite sur notre Site, les données étant alors collectées pour
          nous permettre de mieux répondre à vos demandes d’information sur nos Services et pour
          effectuer un suivi de vos demandes d’exercice de vos droits en application du RGPD. <br />
          (ii) Votre consentement s’agissant des cookies décrits dans notre Politique de Cookies en
          annexe. <br />
          (iii) Cette collecte est nécessaire afin d’exécuter le contrat conclu lorsque vous
          utilisez nos Services. <br />
          (iv) le traitement de vos données peut enfin être nécessaire au respect d’une obligation
          légale à laquelle nous sommes soumis. <br />
          Vos données à caractère personnel sont collectées pour répondre à une ou plusieurs des
          finalités suivantes : <br />
          (i) Gérer votre accès à certains services accessibles sur le Site et leur utilisation,{' '}
          <br />
          (ii) Effectuer les opérations relatives à la gestion des Acheteurs Publics et des
          Entreprises concernant les opérations financières, suivis de la relation avec les
          Acheteurs Publics et les Entreprises, <br />
          (iii) Constituer un fichier d’utilisateurs, de clients et prospects, <br />
          (iv) Adresser des newsletters, sollicitations et messages promotionnels. Dans le cas où
          vous ne le souhaiteriez pas, nous vous donnons la faculté d’exprimer votre refus à ce
          sujet lors de la collecte de vos données ; <br />
          (v) Élaborer des statistiques commerciales et de fréquentation de notre Site, <br />
          (vi) Gérer la gestion des avis des personnes sur les Services proposés, <br />
          (vii) Gérer les impayés et les contentieux éventuels quant à l’utilisation de nos
          Services, <br />
          (viii) Personnaliser les réponses à vos demandes d’information, <br />
          (ix) Respecter nos obligations légales et réglementaires. <br />
          (x) Répondre aux demandes dans le cadre du processus de recrutement. <br />
          (xi) Répondre à vos demandes dans le cadre de l’exercice de vos droits en application du
          RGPD. <br />
          Nous vous informons, lors de la collecte de vos données personnelles, si certaines données
          doivent être obligatoirement renseignées ou si elles sont facultatives. Les données
          obligatoires sont nécessaires pour le fonctionnement des Services. Concernant les données
          facultatives, vous êtes entièrement libre de les indiquer ou non. Nous vous indiquons
          également quelles sont les conséquences éventuelles d’un défaut de réponse. <br />
          <br />
          <br />
          6. DESTINATAIRES DES DONNÉES COLLECTÉES <br />
          Auront accès à vos données à caractère personnel : <br />
          (i) le personnel de notre société, les services chargés du contrôle (commissaire aux
          comptes notamment) ; <br />
          (ii) nos sous-traitants : prestataire d’hébergement, prestataire de gestion des flux
          bancaires, CRM, prestataire d’emailing, prestataire de gestion de projets en ligne. <br />
          Peuvent également être destinataires de vos données à caractère personnel les organismes
          publics, exclusivement pour répondre à nos obligations légales, les auxiliaires de
          justice, les officiers ministériels et les organismes chargés d’effectuer le recouvrement
          de créances. <br />
          <br />
          7. CESSION DES DONNÉES À CARACTÈRE PERSONNEL <br />
          <br />
          Vos données à caractère personnel ne feront pas l’objet de cessions, locations ou échanges
          au bénéfice de tiers. <br />
          <br />
          8. DURÉE DE CONSERVATION DES DONNÉES À CARACTÈRE PERSONNEL <br />
          <br />
          (i) Concernant les données relatives à la gestion des Acheteurs Publics et des Entreprises
          et prospects : <br />
          Vos données à caractère personnel sont conservées pendant la durée strictement nécessaire
          à la gestion de notre relation commerciale avec vous. <br />
          Concernant d’éventuelles opérations de prospection qui vous seraient destinées, vos
          données pourront être conservées pendant un délai de 3 (trois) ans à compter de la fin de
          la relation commerciale. <br />
          Les données permettant d’établir la preuve d’un droit ou d’un contrat, devant être
          conservées au titre du respect d’une obligation légale, le seront pendant la durée prévue
          par la loi en vigueur (5 (cinq) ans conformément à l’article L 561-12 du Code Monétaire et
          Financier). <br />
          Les données à caractère personnel relatives à un prospect, non client, pourront être
          conservées pendant un délai de 3 (trois) ans à compter de leur collecte ou du dernier
          contact émanant du prospect. <br />
          Au terme de ce délai de 3 (trois) ans, nous pourrons reprendre contact avec vous pour
          savoir si vous souhaitez continuer à recevoir des sollicitations commerciales. <br />
          (ii) Concernant les factures : <br />
          Les factures sont conservées pendant une durée de 10 (dix) ans pour nous conformer à nos
          obligations comptables, en application de l’article L. 123-22 du Code de commerce. <br />
          (iii) Concernant la gestion des listes d’opposition à recevoir de la prospection : <br />
          Les informations permettant de prendre en compte votre droit d’opposition sont conservées
          au minimum 3 (trois) ans à compter de l’exercice du droit d’opposition. <br />
          (iv) Concernant la gestion de vos demandes d’exercice de vos droits en application du
          RGPD: <br />
          Les informations permettant la gestion de vos demandes d’exercice de droits en application
          du RGPD seront conservées pendant 2 (deux) ans à compter de la demande. <br />
          <br />
          9. SÉCURITÉ <br />
          <br />
          Nous vous informons prendre toutes précautions utiles, mesures organisationnelles et
          techniques appropriées pour préserver la sécurité, l’intégrité et la confidentialité de
          vos données à caractère personnel et notamment, empêcher qu’elles soient déformées,
          endommagées ou que des tiers non autorisés y aient accès. <br />
          <br />
          10. HÉBERGEMENT <br />
          Nous vous informons que vos données sont conservées et stockées, pendant toute la durée de
          leur conservation sur les serveurs des sociétés situées en France uniquement. <br />
          <br />
          11. COOKIES <br />
          Pour plus d’informations sur les cookies, nous vous renvoyons vers notre Politique de
          Cookies en annexe. <br />
          <br />
          12. ACCÈS, RECTIFICATION ET EFFACEMENT DE VOS DONNÉES À CARACTÈRE PERSONNEL <br />
          <br />
          Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et
          aux libertés, et au RGPD, vous disposez du droit d’obtenir la communication et, le cas
          échéant, la rectification ou l’effacement des données vous concernant. Vous pouvez
          également vous adresser à: <br />
          adresse de courrier électronique : contact@publiconsult.fr <br />
          adresse de courrier postal: LENS GROUP – 2 Bis Avenue du Docteur Cartade – 66310 ESTAGEL{' '}
          <br />
          Il est rappelé aux personnes dont les données sont collectées sur le fondement de notre
          intérêt légitime, comme mentionné à l’article « Collecte des données à caractère personnel
          », qu’elles peuvent à tout moment s'opposer au traitement des données les concernant. Nous
          pouvons toutefois être amenés à poursuivre le traitement s’il existe des motifs légitimes
          pour le traitement qui prévalent sur vos droits et libertés ou si le traitement est
          nécessaire pour constater, exercer ou défendre nos droits en justice. <br />
          13. DROIT DE DÉFINIR DES DIRECTIVES RELATIVES AU TRAITEMENT DES DONNÉES APRÈS VOTRE MORT{' '}
          <br />
          Vous disposez du droit de définir des directives relatives à la conservation, à
          l'effacement et à la communication de vos données à caractère personnel après votre mort.{' '}
          <br />
          Ces directives peuvent être générales, c’est-à-dire qu’elles portent alors sur l’ensemble
          des données à caractère personnel qui vous concernent. Elles doivent dans ce cas être
          enregistrées auprès d’un tiers de confiance numérique certifié par la CNIL. <br />
          <br />
          Les directives peuvent aussi être spécifiques aux données traitées par notre société. Il
          convient alors de nous les transmettre aux coordonnées suivantes : <br />
          adresse de courrier électronique : contact@publiconsult.fr <br />
          adresse de courrier postal: LENS GROUP – 2 Bis Avenue du Docteur Cartade – 66310 ESTAGEL{' '}
          <br />
          En nous transmettant de telles directives, vous donnez expressément votre consentement
          pour que ces directives soient conservées, transmises et exécutées selon les modalités
          prévues aux présentes. <br />
          Vous pouvez désigner dans vos directives une personne chargée de leur exécution. Celle-ci
          aura alors qualité, lorsque vous serez décédé(e), pour prendre connaissance desdites
          directives et nous demander leur mise en œuvre. A défaut de désignation vos héritiers
          auront qualité pour prendre connaissance de vos directives à votre décès et nous demander
          leur mise en œuvre. <br />
          Vous pouvez modifier ou révoquer vos directives à tout moment, en nous écrivant aux
          coordonnées ci-dessus. <br />
          <br />
          14. PORTABILITÉ DE VOS DONNÉES À CARACTÈRE PERSONNEL <br />
          Vous disposez d’un droit à la portabilité des données à caractère personnel que vous nous
          aurez fournies, entendues comme les données que vous avez déclarées activement et
          consciemment dans le cadre de l’accès et de l’utilisation des Services, ainsi que des
          données générées par votre activité dans le cadre de l’utilisation des Services. Nous vous
          rappelons que ce droit ne porte pas sur les données collectées et traitées sur une autre
          base légale que le consentement ou l’exécution du contrat nous liant. <br />
          Ce droit peut être exercé gratuitement, à tout moment, et notamment lors de la fermeture
          de votre compte sur le Site, afin de récupérer et de conserver vos données à caractère
          personnel. <br />
          Dans ce cadre, nous vous adresserons vos données à caractère personnel, par tous moyens
          jugés utiles, dans un format ouvert standard couramment utilisé et lisible par machine,
          conformément à l’état de l’art. <br />
          15. INTRODUCTION D’UNE RÉCLAMATION DEVANT UNE AUTORITÉ DE CONTRÔLE <br />
          Vous êtes également informés que vous disposez du droit d’introduire une réclamation
          auprès d’une autorité de contrôle compétente, (la Commission Nationale Informatique et
          Libertés pour la France), dans l'État membre dans lequel se trouve votre résidence
          habituelle, votre lieu de travail ou le lieu où la violation de vos droits aurait été
          commise, si vous considérez que le traitement de vos données à caractère personnel objet
          de la présente charte constitue une violation des textes applicables. <br />
          Ce recours pourra être exercé sans préjudice de tout autre recours devant une juridiction
          administrative ou juridictionnelle. En effet, vous disposez également d’un droit à un
          recours administratif ou juridictionnel effectif si vous considérez que traitement de vos
          données à caractère personnel objet de la présente charte constitue une violation des
          textes applicables. <br />
          <br />
          16. LIMITATION DU TRAITEMENT <br />
          <br />
          Vous avez le droit d’obtenir la limitation du traitement de vos données personnelles, dans
          les cas suivants : <br />
          Pendant la durée de vérification que nous mettons en œuvre, lorsque vous contestez
          l’exactitude de vos données à caractère personnel, <br />
          <br />
          Lorsque le traitement de ces données est illicite, et que vous souhaitez limiter ce
          traitement plutôt que supprimer vos données, <br />
          Lorsque nous n’avons plus besoin de vos données personnelles, mais que vous souhaitez leur
          conservation pour exercer vos droits, <br />
          Pendant la période de vérification des motifs légitimes, lorsque vous vous êtes opposés au
          traitement de vos données personnelles. <br />
          17. MODIFICATIONS <br />
          <br />
          Nous nous réservons le droit, à notre seule discrétion, de modifier à tout moment la
          présente charte, en totalité ou en partie. Ces modifications entreront en vigueur à
          compter de la publication de la nouvelle charte. Votre utilisation du Site suite à
          l’entrée en vigueur de ces modifications vaudra reconnaissance et acceptation de la
          nouvelle charte. A défaut et si cette nouvelle charte ne vous convient pas, vous ne devrez
          plus accéder au Site. <br />
          <br />
          18. ENTRÉE EN VIGUEUR <br />
          <br />
          La présente charte est entrée en vigueur le 01/06/2023. <br />
          <br />
        </p>
      </div>
    </>
  );
};
